import { useEffect } from "react";
import Connect from "../components/Connect";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function LinkTree() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingCode = urlParams.get("v");

    if (trackingCode) {
      const sourceMap = {
        re: "Resume",
        li: "LinkedIn",
        gh: "GitHub",
        cl: "Cover Letter",
        em: "Email Signature",
        ap: "Application Portal",
        xi: "XING",
      };

      const resolvedSource = sourceMap[trackingCode] || trackingCode;

      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "portfolio_visit", {
          traffic_source: resolvedSource,
        });
      }
    }

    const cleanUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    window.history.replaceState({ path: cleanUrl }, "", cleanUrl);
  }, []);

  const { t } = useTranslation();

  return (
    <div className="w-screen mt-20">
      <Connect />
      <div className="md:hidden px-8 pt-8 pb-4">
        <Link to="/" className="hover:underline">
          <h2 className="text-xl">&gt; {t("homepage.contact.go-to-main")}</h2>
        </Link>
      </div>
    </div>
  );
}
